import styled, { css } from 'react-emotion';
import { Link } from 'react-router-dom';
import controlIcons from './control-icons.png';

export const Diagram = styled.div`
	margin: 1.5rem 0 2.5rem 0;
`;

export const Columns = styled.div`
	display: flex;
`;

export const Column = styled.div`
	align-items: center;
	display: flex;
	flex: 1 0 35%;
	flex-direction: column;
	text-align: center;
`;

export const Name = styled.div`
	color: #000;
	font-size: 1rem;
	font-weight: 400;
`;

export const Party = styled.div`
	font-size: 0.8275rem;
	font-weight: 300;
	margin-bottom: 0.5rem;
	text-transform: uppercase;
`;

export const Bar = styled.div`
	background: #f2f2f2;
	height: 50px;
	margin: 0 auto 0.5rem auto;
	position: relative;
	width: 1rem;

	@media (max-width: 425px) {
		width: 0.5rem;
	}
`;

export const Progress = styled.div`
	background: #888;
	bottom: 0;
	left: 0;
	position: absolute;
	width: 100%;
`;

export const Value = styled.div`
	font-weight: 600;
	text-align: center;
`;

export const Arrow = styled.div`
	flex: 0 0 9%;
`;

export const ArrowPrev = styled(Link)`
	background-position: 0 0;

	&:hover {
		background-position: 0 -88px;
	}
`;

export const ArrowNext = styled(Link)`
	margin-left: auto;
	background-position: 0 -44px;

	&:hover {
		background-position: 0 -132px;
	}
`;

export const ArrowCommon = css`
	background-image: url('${controlIcons}');
	background-repeat: no-repeat;
	display: block;
	height: 34px;
	width: 34px;
`;

export const Elected = styled.span`
	background-color: #ff4900;
	border-radius: 2px;
	color: #fff;
	font-size: 0.75rem;
	padding: 0.25rem;
	text-transform: uppercase;
`;

export const grayscale = css`
	filter: grayscale(100%);
`;

export const withFace = css`
	position: relative;

	img {
		margin-bottom: 0.25rem;
	}

	${Party} {
		margin-bottom: 0;
	}

	${Bar} {
		height: 100px;
		position: absolute;
		right: 1rem;
		top: 0;

		@media (max-width: 525px) {
			right: 0.1rem;
		}
	}

	& + & ${Bar} {
		left: 1rem;
		right: auto;

		@media (max-width: 525px) {
			left: 0.1rem;
		}
	}
`;

export const BarPlaceHolder = styled.div`
	flex: 1 0 35%;
	text-align: center;
	margin: auto;
`
